import {
  Checkbox,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table,
  Td,
  Tr,
} from '@chakra-ui/react'
import { chunk, includes, uniqueId } from 'lodash'
import React from 'react'
import { Button } from '../Button'
import { GridTableColumn } from './types'

const IncludedColumnsModal = ({
  allColumns,
  includedColumns,
  isOpen,
  onClose,
  onColumnChange,
  onReset,
}: {
  allColumns: GridTableColumn[]
  includedColumns: string[]
  isOpen: boolean
  onClose: () => void
  onColumnChange: (recordField: string, includeColumn: boolean) => void
  onReset: () => void
}) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader>Included Columns</ModalHeader>
      <ModalBody>
        <Table variant="unstyled">
          {chunk(allColumns, 2).map(displayRow => (
            <Tr key={uniqueId('row-')}>
              {displayRow.map(({ recordField, label }) => (
                <Td width="50%" padding="0.5rem" key={recordField}>
                  <Checkbox
                    key={recordField}
                    defaultIsChecked={includes(includedColumns, recordField)}
                    marginRight="1rem"
                    onChange={e =>
                      onColumnChange(recordField, e.target.checked)
                    }
                  >
                    {label}
                  </Checkbox>
                </Td>
              ))}
            </Tr>
          ))}
          <Tr>
            <Td colSpan={2}>
              <Button variant="link" onClick={onReset}>
                Reset
              </Button>
            </Td>
          </Tr>
        </Table>
      </ModalBody>
    </ModalContent>
  </Modal>
)

export default IncludedColumnsModal
